import { render, staticRenderFns } from "./vehicle-info-group-detail-modal.vue?vue&type=template&id=2f9822e6"
import script from "./vehicle-info-group-detail-modal.vue?vue&type=script&lang=js"
export * from "./vehicle-info-group-detail-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports